import * as React from "react";
import { APPLICATIONS } from "../../lib/applications";
import merge from "lodash/merge";
import useAppSelector from "../../hooks/useAppSelector";
export default function useApplication() {
    var applicationId = useAppSelector(function (state) { return state.configuration; }).applicationId;
    var application = React.useMemo(function () {
        return applicationId &&
            Object.prototype.hasOwnProperty.call(APPLICATIONS, applicationId)
            ? merge(APPLICATIONS.DEFAULT, APPLICATIONS[applicationId])
            : APPLICATIONS.DEFAULT;
    }, [applicationId]);
    return application;
}
